// extracted by mini-css-extract-plugin
export var diabetesLp__footer__bottom = "Footer-module--diabetesLp__footer__bottom--HpP4I";
export var diabetesLp__footer__bottomLink = "Footer-module--diabetesLp__footer__bottomLink--WU0dY";
export var diabetesLp__footer__cont = "Footer-module--diabetesLp__footer__cont--2+s-p";
export var diabetesLp__footer__para = "Footer-module--diabetesLp__footer__para--R6CPq";
export var diabetesLp__footer__row = "Footer-module--diabetesLp__footer__row--0t9Ci";